export const customPinPanelStyles = {
  customButtons: {
    '& > button': {
      mx: 1,
      my: 0,
    },
    '& button': {
      mx: { sm: 0 },
      my: { sm: 0.5 },
    },
    alignItems: 'center',
    display: 'flex',
    justifyContent: { sm: 'right', xs: 'center' },
    textAlign: { sm: 'left', xs: 'center' },
    width: { sm: '34%' },
  },
  customPin: {
    '& .MuiInputBase-input': {
      p: 0,
    },
    '& fieldset': {
      border: 'none !important',
    },
    alignItems: 'center',
    display: 'flex',
    fontSize: 60,
    fontWeight: 500,
    justifyContent: 'center',
    letterSpacing: '-0.5px',
    lineHeight: '120%',
    mx: 0,
    my: { md: 1.5, sm: 0.25 },
    whiteSpace: 'nowrap',
  },
  helperMessage: {
    color: 'text.secondary',
    pt: 1,
    textAlign: 'center',
  },
  pin: {
    '& h2': {
      fontWeight: 500,
      letterSpacing: 3,
      ml: 1,
      mr: 0,
      my: { md: 1.5, sm: 0.25 },
      whiteSpace: 'nowrap',
    },
    '&:not([data-pin])': {
      color: 'grey.400',
    },
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    mr: { sm: '6%' },
    textAlign: 'center',
    width: { sm: '60%' },
  },
};
